import { useMutation, useQueryClient } from '@tanstack/react-query'

import { RequestsService } from '@/api/models/requests'
import { RequestFeedback } from '@/api/models/requests/lib/requests.types'

import { REQUESTS_LIST_RQ_KEY } from './useRequestsList'

const ADD_REQUEST_FEEDBACK = 'ADD_REQUEST_FEEDBACK'

export const useAddRequestFeedback = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, { body: RequestFeedback }>({
    mutationKey: [ADD_REQUEST_FEEDBACK, id],
    mutationFn: ({ body }) => RequestsService.addRequestFeedback(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [REQUESTS_LIST_RQ_KEY] })
    }
  })
}
